import {Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {StellenService} from '../stellen.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


export interface DialogData {
    animal: string;
    name: string;
}

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

    animal: string;
    name: string;

    constructor(public translate: TranslateService,
                private route: ActivatedRoute,
                private stellenService: StellenService,
                public dialog: MatDialog) {
        translate.setDefaultLang('de');
        if (this.route.snapshot.queryParams.lang &&
            (this.route.snapshot.queryParams.lang === 'de' || this.route.snapshot.queryParams.lang === 'en')) {
            translate.use(this.route.snapshot.queryParams.lang);
            stellenService.lang = this.route.snapshot.queryParams.lang;
        }
        if (this.route.snapshot.queryParams.mandant) {
            stellenService.mandant = this.route.snapshot.queryParams.mandant;
        } else {
            stellenService.mandant = '100';
        }
    }

    ngOnInit() {
        if (this.stellenService.showPopup) {
            this.stellenService.showPopup = false;
            setTimeout(() => this.openDialog());
        }
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(PopupComponent, {
            width: '500px'
        });
    }
}

@Component({
    selector: 'app-popup',
    templateUrl: 'popup.html',
})
export class PopupComponent {

    processId: string;

    constructor(
        private stellenService: StellenService,
        public dialogRef: MatDialogRef<PopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        this.processId = stellenService.processId;
    }

    onOkClick(): void {
        this.dialogRef.close();
    }

}
